const ParHome = () => {
  return <>home</>;
};

export default ParHome;
